<template>
    <div class="swiper" ref="carousel">
        <div class="swiper-wrapper">
            <slot></slot>
        </div>
    </div>
</template>
<script setup>
import Swiper from 'swiper/bundle';
import { onMounted, ref } from 'vue';

const carousel = ref(null);
let swiper = null;

onMounted(()=>{
    swiper = new Swiper(carousel.value, {
        slidesPerView:'auto',
        loop:true,
        centeredSlides:true,
        speed:3000,
        autoplay:{
            delay:0,
            pauseOnMouseEnter:true
        },
        // allowTouchMove: false,
        // disableOnInteraction: true
    })
})


</script>
